<template>
    <div>
        <CancellationRequisition
            ref="cancellationReq"
            @modelChanged="$emit('modelChanged', $event)"
        />
        <CancellationRequisitionLimitDay
            ref="cancellationLimitDayReq"
            @modelChanged="$emit('modelChanged', $event)"
        />
        <Confirm ref="confirm" width="400"></Confirm>
        <ConfirmDelete
            ref="confirmDelete"
            @modelChanged="$emit('modelChanged', $event)"
        />

        <ErpSync ref="erpSync" @modelChanged="$emit('modelChanged', $event)" />

        <ChangeReseller
            ref="changeReseller"
            @modelChanged="$emit('modelChanged', $event)"
        />

        <SendResearch ref="sendResearch" />
    </div>
</template>

<script>
import CancellationRequisition from './CancellationRequisition'
import CancellationRequisitionLimitDay from './CancellationRequisitionLimitDay'
import ChangeReseller from './ChangeReseller'
import Confirm from '@/shared/components/Confirm'
import ConfirmDelete from '@/shared/components/ConfirmDelete'
import ErpSync from './ErpSync'
import SendResearch from './SendResearch'

export default {
    components: {
        CancellationRequisition,
        CancellationRequisitionLimitDay,
        ChangeReseller,
        Confirm,
        ConfirmDelete,
        ErpSync,
        SendResearch,
    },

    methods: {
        async cancellationRequisition(customer) {
            await this.$refs.cancellationReq.open(customer)
        },
        async cancellationRequisitionLimitDay(customer) {
            await this.$refs.cancellationLimitDayReq.open(customer)
        },

        async changeReseller(customer) {
            await this.$refs.changeReseller.open(customer)
        },

        async sendResearch(customer) {
            await this.$refs.sendResearch.open(customer)
        },

        async delete(customer) {
            await this.$refs.confirmDelete.open(customer, customer.trade_name)
        },

        async erpSync(customer) {
            await this.$refs.erpSync.open(customer)
        },

        async restore(model) {
            let confirmed = await this.$refs.confirm.open(
                this.$t('actions.restore.title'),
                this.$t('actions.restore.text', {
                    name: model.trade_name,
                }),
            )
            if (!confirmed) return

            await model.restore()

            this.$emit('modelChanged')
            this.$bus.$emit(
                'notify',
                'success',
                this.$t('actions.restore.success'),
            )
        },
    },
}
</script>

<style></style>
